import React, {Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {isOk, isNetworkError} from "../../utils/apiResponse";
import {FaIcon} from "../FaIcon";
import {Spinner} from "../Spinner";
import {ClientFeatureToggles} from "../client/ClientFeatureToggles";
import {withTranslation} from 'react-i18next';
import {toast} from 'react-toastify';


class EditClientFeaturesModalClass extends Component {
    constructor(props) {
        super(props);
        // Las features son per-(usuario, CLIENTE): con multi-cliente el modal edita las de
        // UN cliente por vez (selector) y el POST manda `client_id` — sin él, el backend
        // responde MISSING_CLIENT a propósito para no elegir uno en silencio.
        const clientIds = props.user.client_ids || [];
        const initialClientId = clientIds.length > 0 ? String(clientIds[0]) : null;
        this.state = {
            modal: false,
            saving: false,
            selectedClientId: initialClientId,
            features: this.featuresForClient(initialClientId),
        };
        this.toggle = this.toggle.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleClientChange = this.handleClientChange.bind(this);
    }

    // Efectivas de ESE cliente (mapa nuevo del payload del equipo), con fallback a las del
    // primario (`client_features` legacy) para la ventana de skew backend viejo.
    featuresForClient(clientId) {
        const byClient = this.props.user.client_features_by_client || {};
        const source = (clientId && byClient[String(clientId)]) || this.props.user.client_features;
        return {
            dashboard: source?.dashboard || false,
            data_explorer: source?.data_explorer || false,
            connect: source?.connect !== false,
            reports: source?.reports !== false,
            insights: source?.insights || false,
            connections: source?.connections || false,
        };
    }

    clientOptions() {
        const ids = this.props.user.client_ids || [];
        const names = this.props.user.client_names || [];
        return ids.map((id, index) => ({id: String(id), name: names[index] || String(id)}));
    }

    toggle() {
        this.setState({modal: !this.state.modal});
    }

    handleClientChange(event) {
        const clientId = event.target.value;
        this.setState({selectedClientId: clientId, features: this.featuresForClient(clientId)});
    }

    handleFeatureToggle(featureKey, checked) {
        this.setState({
            features: {
                ...this.state.features,
                [featureKey]: checked
            }
        });
    }

    handleSave() {
        this.setState({saving: true});
        const url = API_URL + `user/${this.props.user.id}/client-features`;
        const payload = {client_features: this.state.features};
        if (this.state.selectedClientId) {
            payload.client_id = this.state.selectedClientId;
        }
        new APIClient(url).call('POST', payload).then((data) => {
            this.setState({saving: false});
            // `status !== 'OK'`, no `=== 'ERROR'`: por ese literal no entran ni el `NETWORK_ERROR`
            // del `APIClient` ni los códigos tipados del backend, y los dos caían en el `else`,
            // que CIERRA el modal y avisa que se guardó. El usuario se iba convencido de haber
            // cambiado los permisos de un cliente sin que se hubiera escrito nada.
            if (!isOk(data)) {
                // Un fallo de red lleva copy PROPIA: el `error_message` del objeto que arma
                // `APIClient` esta hardcodeado en espanol, asi que mostrarlo le escribe en espanol
                // a un usuario en ingles. El resto conserva el mensaje tipado del backend.
                toast.error(isNetworkError(data)
                    ? this.props.t('invite_user.error_network')
                    : (data['error_message'] || this.props.t('invite_user.generic_error')));
            } else {
                this.toggle();
                if (this.props.onSaved) this.props.onSaved();
            }
        });
    }

    render() {
        const {t, user} = this.props;
        const clientOptions = this.clientOptions();
        const isMultiClient = clientOptions.length > 1;

        return (
            <>
                <a onClick={this.toggle} style={{cursor: 'pointer'}} title={t('agency_team.edit_features')}>
                    <FaIcon iconName="user-edit"/>
                </a>
                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        <FaIcon iconName="user-edit"/>
                        {t('edit_client_features.title')}
                    </ModalHeader>
                    <ModalBody>
                        <div className="modal-section">
                            <div style={{marginBottom: '1.2em'}}>
                                <strong>{user.name}</strong>
                                <div style={{fontSize: '0.85em', color: '#999'}}>{user.email}</div>
                                {!isMultiClient && user.client_name && (
                                    <div style={{fontSize: '0.85em', color: '#999', marginTop: '0.2em'}}>
                                        {t('agency_team.client_label')}: {user.client_name}
                                    </div>
                                )}
                            </div>
                            {isMultiClient && (
                                <div className="form-row" style={{marginBottom: '1em'}}>
                                    <label>{t('agency_team.client_label')}</label>
                                    <select
                                        className="form-control"
                                        value={this.state.selectedClientId || ''}
                                        onChange={this.handleClientChange}
                                    >
                                        {clientOptions.map(option => (
                                            <option key={option.id} value={option.id}>{option.name}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <label>{t('invite_user.client_features_label')}</label>
                            <ClientFeatureToggles
                                features={this.state.features}
                                onChange={(key, checked) => this.handleFeatureToggle(key, checked)}
                            />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.saving ? (
                            <Spinner color="positive small"/>
                        ) : (
                            <button className="btn -alt" onClick={this.handleSave}>
                                {t('edit_client_features.save')}
                            </button>
                        )}
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

export const EditClientFeaturesModal = withTranslation()(EditClientFeaturesModalClass);
